"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GRAPHQL_EXTERNAL_SUPPLIERNET_URL = void 0;

var _createExternalSupplierNetAppolloClient = _interopRequireDefault(require("./utils/createExternalSupplierNetAppolloClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// export const GRAPHQL_EXTERNAL_SUPPLIERNET_URL =
//   "https://suppliernet-qa.elcompanies.com/gateway_suppliernet_master/graphql";
var GRAPHQL_EXTERNAL_SUPPLIERNET_URL = process.env.NODE_ENV === "production" ? "/gateway_suppliernet_master/graphql" : "https://suppliernet-qa.elcompanies.com/gateway_suppliernet_master/graphql";
exports.GRAPHQL_EXTERNAL_SUPPLIERNET_URL = GRAPHQL_EXTERNAL_SUPPLIERNET_URL;

var _default = (0, _createExternalSupplierNetAppolloClient.default)(GRAPHQL_EXTERNAL_SUPPLIERNET_URL, {
  appName: "SupplierNet PO"
});

exports.default = _default;